import { render, staticRenderFns } from "./WkApprovalFlowApply.vue?vue&type=template&id=6378b129&scoped=true"
import script from "./WkApprovalFlowApply.vue?vue&type=script&lang=js"
export * from "./WkApprovalFlowApply.vue?vue&type=script&lang=js"
import style0 from "./WkApprovalFlowApply.vue?vue&type=style&index=0&id=6378b129&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6378b129",
  null
  
)

export default component.exports